<template>
<div class="additional-criteria">
	<div class="select" @click="showMenu = !showMenu">
		<grid>
			<grid-item size="31/40" class="title">
				{{ label }}
			</grid-item>
			<grid-item size="9/40">
				<i class="icon-down-open"></i>
			</grid-item>
		</grid>
	</div>
	<ul v-if="showMenu" v-click-outside="hideList">
		<li v-for="(item, index) in itemList" :key="index" @click="item.status = !item.status">
			<span v-if="item.status" class="active">
				{{ item.name }}
			</span>
			<span v-else>
				{{ item.name }}
			</span>
		</li>
	</ul>
</div>
</template>

<script>
export default {
	props: ['label', 'itemList'],
	data: () => ({
		showMenu: false
	}),
	methods: {
		hideList() {
			this.showMenu = false
		}
	}
}
</script>

<style lang="scss">
.additional-criteria {
	.select {
		background-color: rgba(20, 26, 33, 0.8);
		color: #fff;
		border: none;
		font-weight: 700;
		padding: 11px 15px 10px;
		margin: 0;
		line-height: 24px;
		border-radius: 0;
		user-select: none;
		cursor: pointer;

		&:hover {
			background: #293747;
		}

		.title {
			font-size: 13px;
			line-height: 24px;
			text-align: left;
			padding-left: 18px !important;
			font-weight: 500;
		}

		i {
			font-size: 14px;
			border-left: 1px solid #808080;
			padding-left: 12px;
			line-height: 25px;
			display: inline-block;
			color: #808080;
		}
	}

	ul {
		list-style: none;
		padding: 10px;
		margin: 1px 0 0 0;
		background: #1d232a;
		position: absolute;
		width: 236px;
		z-index: 2;

		span {
			color: #999999;
			border: 1px solid #8a8c91;
			display: inline-block;
			padding: 5px 10px;
			border-radius: 15px;
			margin: 0px 5px 7px 0px;
			user-select: none;
			cursor: pointer;
			float: left;
			text-transform: uppercase;
			font-size: 10px;
		}

		span.active {
			background: #e8e5dc;
			color: #000;
		}
	}
}
</style>
